module.exports = {
    landing: {
        warranty: '24 mesi di garanzia'
    }
}